module.exports = __webpack_public_path__ + "fonts/GT-America-Expanded-Bold.ddd617f0.woff2";